import React, { useState, Fragment } from 'react';
import { Box, Card, CardContent, Typography } from '@material-ui/core';
import { useGlobal } from '@rcg/ui-react';
import RCCL_UUID from '@rcg/uuid';
import useStyles from './index.style';
import { setPosition } from '../../commons';

const StateroomCard = ({
  room: { guests, type, subType, location, deck, number, guarantee, image },
  stateroomEditClick,
  renderViewGuestInfoCta,
}) => {
  const classes = useStyles();
  const { renderContent } = useGlobal();
  const [loadFallback, setLoadFallback] = useState(false);
  const fallbackImg =
    'https://assets.dm.rccl.com/is/image/RoyalCaribbeanCruises/royal/accommodations/iobd/default-stateroom-photo.jpg';

  const stateroomImg = image && image.replace(/<resolution>/g, '1440');

  const handleKeyDown = (e, guestNumber) => {
    if (e.key === 'Enter' || e.key === ' ') {
      stateroomEditClick(e, guestNumber);
    }
  };

  const guestEditButton = (label, guestNumber, testId) => {
    if (renderViewGuestInfoCta) {
      return (
        <div className={classes.plainGuestNameContainer}>
          <Typography
            data-testid={testId}
            className={classes.details}
            variant="body1"
            data-cs-mask
            component="span">
            {label}
          </Typography>
        </div>
      );
    }
    return (
      <div className={classes.interactiveGuestNameContainer}>
        <Typography
          data-testid={testId}
          className={classes.details}
          variant="body1"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => handleKeyDown(e, guestNumber)}
          onClick={(e) => stateroomEditClick(e, guestNumber)}
          component="span">
          {label}
        </Typography>
      </div>
    );
  };

  return (
    <Card className={classes.rootStateroomCard}>
      {loadFallback ? (
        <img
          src={fallbackImg}
          alt={subType}
          className={`${classes.cardImg} ${classes.fallbackImg}`}
        />
      ) : (
        <img
          src={stateroomImg}
          alt={subType}
          className={classes.cardImg}
          onError={() => setLoadFallback(true)}
        />
      )}
      <CardContent className={classes.card}>
        <Box className="header">
          <Box className="title-container" />
          <Typography className="title">
            {guarantee
              ? `${type.toLowerCase()} ${renderContent(
                  'stateroomBookingAmendGuaranteeLabel',
                  'Guarantee',
                ).toLowerCase()}`
              : `${subType}, #${number}`}
          </Typography>
          {deck && (
            <>
              <Typography className="room-labels__label" component="span">
                {`${renderContent('stateroomBookingAmendDeckLabel', 'Deck')}  ${deck}`}
              </Typography>
              <Typography className="room-labels__label" component="span">
                {setPosition(location)}
              </Typography>
            </>
          )}
        </Box>
        <Box className="content">
          <Box className={classes.contentWrapper}>
            <Typography className={classes.subtitle} component="span">
              {renderContent('stateroomBookingAmendGuestsLabel', 'Guests')}
            </Typography>
            <>
              {guests?.map((guest, guestNumber) => {
                if (guest.firstName === 'TBA' || guest.firstName === 'TBD') {
                  return (
                    <Fragment key={`guest-tba-${RCCL_UUID.getRWDId()}`}>
                      {guestEditButton(
                        `${renderContent('stateroomBookingAmendGuestLabel', 'Guest')} ${
                          guestNumber + 1
                        }`,
                        guestNumber,
                        `guest-tba-${guestNumber}`,
                      )}
                    </Fragment>
                  );
                }
                return (
                  <Fragment key={`guest-name-${RCCL_UUID.getRWDId()}`}>
                    {guestEditButton(
                      `${guest.firstName.toLowerCase()} ${guest.lastName.toLowerCase()}`,
                      guestNumber,
                      `guest-name-${guestNumber}`,
                    )}
                  </Fragment>
                );
              })}
            </>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StateroomCard;
